"use client";

import { ActionIcon, Button, Card, Group, Text } from "@mantine/core";
import Link from "next/link";

import { CloseIcon, EditIcon } from "@/components/ui/elements";
import classes from "./_css/UnreviewedWarning.module.css";

type Props = {
  unreviewedCount: number;
  onDismiss?: () => void;
};

export function UnreviewedWarning({ unreviewedCount, onDismiss }: Props) {
  if (unreviewedCount === 0) return <></>;

  return (
    <Card className={classes.card} p="lg" radius="lg">
      <Group gap="sm" align="flex-start" wrap="nowrap">
        <EditIcon className={classes.icon} size={28} aria-hidden="true" />
        <div className={classes.body}>
          <Text className={classes.title}>
            {unreviewedCount}件の未評価勤務があります
          </Text>
          <div className={classes.actionRow}>
            <Text className={classes.description}>
              勤務の評価をお願いします。評価完了で持ち点が1pt加算されます。
            </Text>
            <Button
              component={Link}
              className={classes.button}
              size="md"
              variant="filled"
              color="teal"
              radius="xl"
              href="/workSchedule/complete"
            >
              評価する
            </Button>
          </div>
        </div>
        {onDismiss ? (
          <ActionIcon
            aria-label="未評価勤務のお知らせを閉じる"
            size="sm"
            variant="subtle"
            color="gray"
            onClick={onDismiss}
          >
            <CloseIcon size={14} />
          </ActionIcon>
        ) : null}
      </Group>
    </Card>
  );
}
